import React from "react";
import { TickIcon } from "assets";
import { PersonalInfoData } from "./types";

interface ProgressStepsProps {
  stage: number;
  setStage: React.Dispatch<React.SetStateAction<number>>;
  personal: PersonalInfoData;
  personalData: PersonalInfoData | undefined;
}

export const ProgressSteps: React.FC<ProgressStepsProps> = ({
  stage,
  setStage,
  personal,
  personalData
}) => {
  // Step 1 is complete if personal info is filled
  const isStep1Complete = personal.firstName !== "" && personal.lastName !== "";
  // Step 2 is complete if we're on step 3 (meaning step 2 was submitted)
  const isStep2Complete = stage > 2;

  return (
    <div className="flex w-fit mx-auto mb-8">
      {/* Step 1 */}
      <span
        role="button"
        onClick={() => setStage(1)}
        className={`
          border sm:w-10 sm:h-10 w-7 h-7 rounded-full
          flex justify-center items-center font-medium sm:text-lg cursor-pointer
          ${stage === 1
            ? 'bg-[#012169] text-white border-[#012169]'
            : isStep1Complete
              ? 'border-green-600 bg-white text-green-600'
              : 'border-[#012169] text-[#012169]'
          }
        `}
      >
        {isStep1Complete && stage !== 1 ? <TickIcon /> : "1"}
      </span>

      {/* Step 2 */}
      <span
        role={isStep1Complete ? "button" : ""}
        onClick={() => isStep1Complete && setStage(2)}
        className={`
          border sm:w-10 sm:h-10 w-7 h-7 rounded-full
          flex justify-center items-center font-medium sm:text-lg sm:ml-36 ml-14 relative
          [@media(min-width:1020px)_and_(max-width:1200px)]:ml-20
          ${isStep1Complete ? 'cursor-pointer' : ''}
          ${stage === 2
            ? 'bg-[#012169] text-white border-[#012169]'
            : isStep2Complete
              ? 'border-green-600 bg-white text-green-600'
              : 'border-[#012169] text-[#012169]'
          }
          before:content-[''] before:h-[1px] sm:before:w-36 before:w-14 before:block
          before:bg-[#012169] before:absolute sm:before:right-10 before:right-7
          before:[@media(min-width:1020px)_and_(max-width:1200px)]:w-20
          before:[@media(min-width:1020px)_and_(max-width:1200px)]:right-10
        `}
      >
        {isStep2Complete && stage !== 2 ? <TickIcon /> : "2"}
      </span>

      {/* Step 3 */}
      <span
        role={isStep2Complete ? "button" : ""}
        onClick={() => isStep2Complete && setStage(3)}
        className={`
          border sm:w-10 sm:h-10 w-7 h-7 rounded-full
          flex justify-center items-center font-medium sm:text-lg sm:ml-36 ml-14 relative
          [@media(min-width:1020px)_and_(max-width:1200px)]:ml-20
          ${isStep2Complete ? 'cursor-pointer' : ''}
          ${stage === 3
            ? 'bg-[#012169] text-white border-[#012169]'
            : 'border-[#012169] text-[#012169]'
          }
          before:content-[''] before:h-[1px] sm:before:w-36 before:w-14 before:block
          before:bg-[#012169] before:absolute sm:before:right-10 before:right-7
          before:[@media(min-width:1020px)_and_(max-width:1200px)]:w-20
          before:[@media(min-width:1020px)_and_(max-width:1200px)]:right-10
        `}
      >
        3
      </span>
    </div>
  );
};